import axios from "./index.service";

export default class StudentService {
  static fetchAllStudent(pageAble) {
    return axios({
      method: "GET",
      url: `/api/services/v1/student/list-all`,
      params: pageAble,
    });
  }

  static activateAccount(payload, matricNumber) {
    return axios({
      method: "PUT",
      url: "/api/services/v1/student/activate-account",
      data: payload,
      params: {
        name: matricNumber,
      },
    });
  }

  static fetchStudentInfo(matricNumber) {
    return axios({
      method: "GET",
      url: "/api/services/v1/student/student-info",
      params: {
        matricNumber: matricNumber,
      },
    });
  }

  static fetchUserProfile(studentId) {
    return axios({
      method: "GET",
      url: `/api/services/v1/student/profile/${studentId}`,
    });
  }

  static fetchPeopleYouMayKnow(pageAble) {
    console.log("pageAble ", pageAble);
    return axios({
      method: "GET",
      url: `/api/services/v1/student/people-you-might-know`,
      params: pageAble,
    });
  }

  static uploadStudentFile(image) {
    var bodyFormData = new FormData();
    bodyFormData.append("student-file", image);
    return axios({
      method: "POST",
      url: "/api/services/v1/student/upload-students-file",
      data: bodyFormData,
    });
  }

  static fetchByGraduationYear(value, pageAble) {
    const payload = { page: 0, size: 1000000, year: value };
    console.log({ payload });
    return axios({
      method: "GET",
      url: `/api/services/v1/student/fetchByGraduationYear`,
      params: payload,
    });
  }

  static fetchByProgram(value, pageAble) {
    const payload = { page: 0, size: 1000000, program: value };
    console.log({ payload });
    return axios({
      method: "GET",
      url: `/api/services/v1/student/fetchByProgram`,
      params: payload,
    });
  }

  static delete(id) {
    return axios({
      method: "DELETE",
      url: `/api/services/v1/student/${id}`,
    });
  }

  static assignRole(id, role) {
    return axios({
      method: "PUT",
      url: `/api/services/v1/student/assign-role/${id}`,
      params: { role: role },
    });
  }

  static assignOffice(id, payload) {
    return axios({
      method: "PUT",
      url: `/api/services/v1/student/assign-office/${id}`,
      data: payload,
    });
  }

  static fetchMemberDirectory(pageAble) {
    const payload = { page: 0, size: 1000000 };
    return axios({
      method: "GET",
      url: `/api/services/v1/student/office-member-directory`,
      params: payload,
    });
  }

  static retractOffice(id) {
    return axios({
      method: "PATCH",
      url: `/api/services/v1/student/retract-office/${id}`,
    });
  }

  static fetchByLastName(lastName) {
    return axios({
      method: "GET",
      url: `/api/services/v1/student/search`,
      params: {
        lastName: lastName,
      },
    });
  }
}
